<template>
    <div class="customer">
        <div class="customer-icon" @click="openService">
            <van-icon name="service" color="#666666" class="icon-icon" />
        </div>
        <div class="customer-box" v-if="customerListShow || chatShow">
            <div class="customer-content" v-if="customerListShow">
                <customerService :typeNav="2" @close="closeService" />
            </div>
            <div class="customer-content" v-if="chatShow">
                <chatContent :typeNav="2" @close="openService" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex"
    import chatContent from "@/views/chat/index.vue"
    import customerService from "@/views/customerService/index.vue"
    export default {
        name: 'Customer',
        components: { chatContent, customerService },
        computed: {
            ...mapGetters(['customerListShow', 'chatShow'])
        },
        methods: {
            ...mapActions(['setCustomerListShow', 'setChatShow']),
            openService() {
                let windowWidth = window.innerWidth;
                if (windowWidth < 800) {
                    this.$router.push('/customerService')
                    return
                }
                if (this.customerListShow || this.chatShow) {
                    this.setCustomerListShow(false)
                    this.setChatShow(false)
                    return
                }
                this.setCustomerListShow(true)
            },
            closeService(e) {
                if (e) {
                    this.setCustomerListShow(false)
                    this.setChatShow(true)
                } else {
                    this.openService()
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.customer {
    width: 56px;
    height: 56px;
    position: fixed;
    right: 20px;
    bottom: 40px;
    z-index: 99;
}
.customer-icon {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 3px rgba(200, 200, 200, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.icon-icon {
    font-size: 28px;
}
.customer-box {
    position: absolute;
    right: 0;
    bottom: calc(100% + 20px);
    width: 30vw;
    height: 50vw;
    max-width: 300px;
    max-height: 500px;
    background: #FFFFFF;
    box-shadow: 0 0 3px rgba(200, 200, 200, 0.6);
    border-radius: 10px;
    overflow: hidden;
    .customer-content {
        width: 100%;
        height: 100%;
        overflow-y: overlay;
    }
}

::v-deep .van-nav-bar--fixed, ::v-deep .input {
    position: absolute;
}

::v-deep .records-wrapper {
    min-height: 100%;
    height: fit-content;
}

@media only screen and (max-width:800px) {
    .customer {
        width: 40px;
        height: 40px;
    }
    .icon-icon {
        font-size: 20px;
    }
}
</style>